import {Phase2Api} from "../api";
import {useApolloClient} from "react-apollo";
import {SET_STATUS} from "./action";
import {ScheduledToExpectedPaxCgoMutation} from "./graphql";
import {getSelectedEntities} from "./util";

export function useMutationDispatcher(api: Phase2Api){
    const apolloClient = useApolloClient();

    const dispatch = api.getDispatch();

    return async function start(){

        dispatch({ type: SET_STATUS, payload: { status: 'LOADING' } });

        try {

            const entities = getSelectedEntities(api);

            const pax = entities.filter((e) => e.classType === 'flytsuite.paxnode');
            const cgo = entities.filter((e) => e.classType === 'flytsuite.cgonode');

            await apolloClient.mutate({
                mutation: ScheduledToExpectedPaxCgoMutation,
                variables: {
                    paxIDs: pax.map((p) => p._id),
                    cgoIDs: cgo.map((c) => c._id)
                }
            })

            dispatch({ type: SET_STATUS, payload: { status: 'SUCCESS' } });
        }
        catch (error){
            console.error('Failed to convert pax/cgo to expected:', error);
            dispatch({ type: SET_STATUS, payload: { status: 'ERROR' , error: error } });
            throw error;
        }

    }
}